import { render } from "./CustomerHome.vue?vue&type=template&id=718de608"
import script from "./CustomerHome.vue?vue&type=script&lang=js"
export * from "./CustomerHome.vue?vue&type=script&lang=js"
script.render = render

export default script